import { useState, useRef } from 'react'

export const useVideoPlayer = () => {
    const [isPlaying, setIsPlaying] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)
    const videoRef = useRef<HTMLVideoElement | null>(null)

    const togglePlay = () => {
        if (videoRef.current && !isButtonDisabled) {
            if (isPlaying) {
                videoRef.current.pause()
            } else {
                videoRef.current.play()
            }

            setIsButtonDisabled(true)
            setIsPlaying(!isPlaying)

            setTimeout(() => {
                setIsButtonDisabled(false)
            }, 300)
        }
    }

    const handleVideoEnd = () => {
        setIsPlaying(false)
    }

    return {
        isPlaying,
        isButtonDisabled,
        videoRef,
        togglePlay,
        handleVideoEnd,
    }
}
